import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromActivityLog from './activity-log.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ActivityLogEffects } from './activity-log.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromActivityLog.activityLogFeatureKey,
      fromActivityLog.reducer
    ),
    EffectsModule.forFeature([ActivityLogEffects]),
  ],
})
export class ActivityLogModule {}
